<template>
  <div class="edit-container">
    <div class="container-box">
      <div class="back-btn"><el-button type="text" @click="goLogin">返回登录</el-button></div>
      <!-- <img class="logo" src="@/assets/logo-red.png" alt="" /> -->

      <!-- 第一步 -->
      <!--<el-tabs v-show="stepOne === 1" v-model="activeName" @tab-click="handleClickTab">
       <el-tab-pane label="手机" name="sms">
          <el-form ref="MobileLoginForm" :model="loginForm" :rules="loginRules" class="login-form-mobile" label-width="100px" label-position="left">
            <el-form-item prop="mobile" label="手机">
              <el-input ref="mobile" v-model="loginForm.mobile" placeholder="请输入手机号码" autocomplete="newpassword" />
            </el-form-item>

            <el-form-item prop="graphicCode" label="图形验证码">
              <div class="flex">
                <el-input ref="graphicCode" v-model="loginForm.graphicCode" class="w70" placeholder="请输入图形码" autocomplete="newpassword" />
                <div class="graphic-code" @click="changeCaptcha"><img :src="'data:image/png;base64,' + captchaURL" alt="" /></div>
              </div>
            </el-form-item>

            <el-form-item prop="authCode" label="验证码">
              <div class="flex">
                <el-input ref="authCode" v-model="loginForm.authCode" class="w70" placeholder="请输入验证码" name="graphicCode" tabindex="3" autocomplete="newpassword" />
                <el-button class="send-btn" :disabled="disabled" type="primary" plain @click="getCode">{{ time }}</el-button>
              </div>
            </el-form-item>

            <el-button class="next-btn" type="primary" @click.native.prevent="handleNext('MobileLoginForm')">下一步</el-button>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="邮箱" name="email">

        </el-tab-pane>
      </el-tabs> -->
      <el-form v-show="stepOne === 1" ref="EmailLoginForm" :model="loginForm" :rules="loginRules" class="login-form-mobile" label-width="100px" label-position="left">
        <el-form-item prop="email" label="邮箱">
          <el-input v-model="loginForm.email" placeholder="请输入邮箱" autocomplete="newpassword" />
        </el-form-item>

        <el-form-item prop="graphicCode" label="图形验证码">
          <div class="flex">
            <el-input ref="graphicCode" v-model="loginForm.graphicCode" class="w70" placeholder="请输入图形码" autocomplete="newpassword" />
            <div class="graphic-code" @click="changeCaptcha">
              <img :src="'data:image/png;base64,' + captchaURL" alt="" />
            </div>
          </div>
        </el-form-item>

        <el-form-item prop="authCode" label="验证码">
          <div class="flex">
            <el-input ref="authCode" v-model="loginForm.authCode" class="w70" placeholder="请输入验证码" autocomplete="newpassword" />
            <el-button class="send-btn" type="primary" plain @click="getCode(loginForm.mobile)">{{ time }}</el-button>
          </div>
        </el-form-item>

        <el-button class="next-btn" type="primary" @click.native.prevent="handleNext('EmailLoginForm')">下一步</el-button>
      </el-form>

      <!-- 第二步 -->
      <el-form v-show="stepOne === 2" ref="newPasswordFormRef" :model="newPasswordForm" :rules="passwordRules" class="login-form-mobile" label-width="100px" label-position="left">
        <div class="title">
          <h2>修改密码</h2>
        </div>
        <el-form-item prop="password" label="新密码">
          <el-input v-model="newPasswordForm.password" show-password clearable type="password" placeholder="请输入新密码" autocomplete="newpassword" @blur="passwordChange" />
        </el-form-item>
        <el-form-item prop="rePassword" label="确认密码">
          <el-input v-model="newPasswordForm.rePassword" show-password clearable type="password" placeholder="请再次输入密码" autocomplete="newpassword" @blur="passwordChange" />
        </el-form-item>
        <el-form-item>
          <ol class="tips-list">
            <li v-if="open_strong_passwd > 1" :class="rule1">密码必须由“小写字母”、“大写字母”、“数字”、“特殊符号”的四种组成，区分大小写</li>
            <li :class="rule2">密码长度应在8-20位长度，不能有空格。</li>
            <li :class="rule3">密码中不应该有连续重复的组合</li>
          </ol>
        </el-form-item>
        <div class="post-btn">
          <el-button :loading="loading" type="primary" style="width: 100%" @click="submitChanPassword">确认</el-button>
        </div>
      </el-form>
    </div>
    <div class="footer-login">Copyright {{ new Date().getFullYear() }} @ 同等学力学习系统</div>
  </div>
</template>

<script>
import { validateField } from '@/utils/validate'
import { mapState } from 'vuex'
export default {
  data() {
    const validategraphicCode = (rule, value, callback) => {
      if (value.length < 4) {
        callback(new Error('请正确输入图形码'))
      } else {
        callback()
      }
    }

    const validateauthCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'))
        return
      }

      if (value.length < 4) {
        callback(new Error('请正确输入验证码'))
      } else {
        callback()
      }
    }

    const validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }

    const validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.newPasswordForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    // 这里存放数据
    return {
      disabled: false,
      stepOne: 1,
      activeName: 'email',
      loginForm: {
        mobile: '',
        authCode: '',
        graphicCode: '',
        email: ''
      },
      loginRules: {
        mobile: [{ required: true, trigger: 'blur', validator: validateField('phone') }],
        email: [{ required: true, trigger: 'blur', validator: validateField('email') }],
        graphicCode: [{ required: true, trigger: 'blur', validator: validategraphicCode }],
        authCode: [{ required: true, trigger: 'blur', validator: validateauthCode }]
      },
      passwordRules: {
        password: { required: true, trigger: 'blur', validator: validatePass },
        rePassword: { required: true, trigger: 'blur', validator: validatePass2 }
      },
      newPasswordForm: {
        password: '',
        rePassword: ''
      },
      loading: false,
      time: '发送',
      timer: null,
      open_strong_passwd: 1,
      rule1: null,
      rule2: null,
      rule3: null
    }
  },
  computed: {
    ...mapState('user', ['captchaURL'])
  },
  watch: {},
  mounted() {
    this.$store.dispatch('user/CreateSid')
  },

  methods: {
    // 获取短信验证码
    async getCode(mobile) {
      switch (this.activeName) {
        case 'sms':
          if (!mobile) {
            return this.$message.error('请先输入手机号码')
          }
          break
        case 'email':
          if (!this.loginForm.email) {
            return this.$message.error('请先输入您的邮箱')
          }
          break
      }

      if (!this.loginForm.graphicCode) {
        return this.$message.error('请先输入图形验证码')
      }

      let postdata = {}

      if (this.activeName === 'sms') {
        postdata = {
          mode: this.activeName,
          mobile: this.loginForm.mobile,
          verificationCode: this.loginForm.graphicCode
        }
      } else {
        postdata = {
          mode: this.activeName,
          email: this.loginForm.email,
          verificationCode: this.loginForm.graphicCode
        }
      }

      this.$store.dispatch('user/SendVerifyCode', postdata).then(res => {
        if (+res.code === 200) {
          this.disabled = true
          this.$message.success('已发送，请注意查收！')
          if (this.time === '发送') {
            let num = 60
            this.time = num + 'S'
            setInterval(() => {
              if (num > 0) {
                num--
                this.time = num + 'S'
              } else {
                this.disabled = false
                this.time = '发送'
              }
            }, 1000)
          }
        }
      })
    },

    // 切换tab栏
    handleClickTab(tab, event) {
      this.loginForm = {}
      this.$store.dispatch('user/CreateSid')
    },

    // 下一步
    handleNext(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.stepOne = 2
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    passwordChange() {
      if (!this.newPasswordForm.password) {
        this.rule1 = null
        this.rule2 = null
        this.rule3 = null
        return
      }

      if (this.newPasswordForm.password && this.newPasswordForm.password === this.newPasswordForm.rePassword) {
        // 密码必须含有“小写字母”、“大写字母”、“数字”、“特殊符号”的四种
        var rC = {
          lW: '[a-z]', // 小写字母
          uW: '[A-Z]', // 大写字母
          nW: '[0-9]', // 数字
          sW: '[\\u0020-\\u002F\\u003A-\\u0040\\u005B-\\u0060\\u007B-\\u007E]' // 特殊字符
        }

        // eslint-disable-next-line no-inner-declarations
        function Reg(str, rStr) {
          var reg = new RegExp(rStr)
          return reg.test(str)
        }

        var tR = {
          l: Reg(this.newPasswordForm.password, rC.lW),
          u: Reg(this.newPasswordForm.password, rC.uW),
          n: Reg(this.newPasswordForm.password, rC.nW),
          s: Reg(this.newPasswordForm.password, rC.sW)
        }

        if (this.open_strong_passwd > 0) {
          // 密码长度应在8-16位长度，不能有空格。
          if (tR.l && tR.u && tR.n && tR.s) {
            this.rule1 = 'success'
          } else {
            this.rule1 = 'error'
          }
        }

        // 密码中不应该有连续重复的组合
        if (this.newPasswordForm.password.length < 8 || this.newPasswordForm.password.length > 20 || /\s+/g.test(this.newPasswordForm.password)) {
          this.rule2 = 'error'
        } else {
          this.rule2 = 'success'
        }
        // 重复连续数据
        if (/(\w)\1{2}/.test(this.newPasswordForm.password)) {
          this.rule3 = 'error'
        } else {
          this.rule3 = 'success'
        }
      }
    },

    submitChanPassword() {
      this.$refs.newPasswordFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          const data = {
            mode: this.activeName,
            verifyCode: this.loginForm.authCode,
            ...this.newPasswordForm
          }
          this.$store.dispatch('user/restPasswod', data).then(res => {
            if (+res.code === 200) {
              this.$message.success('密码修改成功!')
              setTimeout(() => {
                this.$router.replace('/')
              }, 500)
            } else {
              this.$message.error('密码修改失败，请稍后再试!')
            }
            this.loading = false
          })
        }
      })
    },

    // 返回登录
    goLogin() {
      this.$router.push({ path: '/login' })
    },
    changeCaptcha() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.$store.dispatch('user/Captcha')
        clearTimeout(this.timer)
      }, 500)
    }
  }
}
</script>

<style scoped lang="scss">
$bg: #f2f2f2;
$red: #c14e4e;

.tips-list {
  color: #bbb;
  padding: 0 15px;
  line-height: 20px;

  .success {
    color: #67c23a;
  }

  .error {
    color: #f56c6c;
  }
}

.flex {
  display: flex;
  align-items: center;
}

.edit-container {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  // background-color: $bg;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: url('@/assets/bg.png') no-repeat;
  background-size: cover;
  background-position: center;
}

.container-box {
  background-color: #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 0px 14px 0px #ececec;
  padding: 44px 35px 35px 35px;
  border-radius: 14px;
  margin: auto 0;
  .back-btn {
    color: #333333;
    margin-bottom: 30px;

    &:hover {
      cursor: pointer;
    }
  }

  .logo {
    width: 430px;
    height: 49px;
    display: block;
    margin: 0 auto;
  }
}

.login-form-mobile {
  .send-btn {
    width: 120px;
    margin-left: 30px;
  }

  .w70 {
    width: 200px;
  }

  .graphic-code {
    width: 120px;
    height: 40px;
    margin-left: 30px;
    cursor: pointer;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .next-btn {
    width: 100%;
  }
}

:deep(.el-tabs__nav-wrap .el-tabs__nav) {
  width: 100% !important;
  display: flex !important;
}

:deep(.el-tabs__nav-wrap .el-tabs__item) {
  flex: 1 !important;
  width: 100% !important;
  text-align: center;
}

:deep(.el-tabs__nav-wrap .el-tabs__active-bar) {
  width: 50% !important;
}

.top-head {
  width: 100%;
  height: 66px;
  background: #ffffff;
  box-shadow: 0px 2px 28px 0px rgba(0, 0, 0, 0.05);

  > div {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .head-logo {
    width: 328px;
    height: 40px;
    background-size: 100% 100%;
  }

  .single-menu {
    display: flex;
    margin: 0;
    padding: 0;
    justify-content: flex-start;
    align-items: center;

    li {
      list-style: none;

      a {
        color: #777777;
      }

      &:hover {
        a {
          color: var(--theme-color);
        }
      }

      &:not(:last-child) {
        &::after {
          content: '|';
          margin: 0 20px;
          color: #777777;
        }
      }
    }
  }
}

.footer-login {
  position: relative;
  height: 66px;
  line-height: 66px;
  font-size: var(--content-font-size);
  color: #999999;
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;

  h2 {
    font-size: 20px;
    font-weight: 500;
    color: #333;
  }
}
</style>
